import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { CRM_COLORS } from '../../../../theme/crmColors';

// Etiqueta gris sobre su valor, como en las tarjetas del diseño.
const useStyles = makeStyles({
    label: {
        display: 'block',
        fontSize: '0.8125rem',
        fontWeight: 400,
        color: CRM_COLORS.text.secondary,
        lineHeight: 1.3,
    },
    value: {
        fontSize: '0.9375rem',
        fontWeight: 400,
        color: CRM_COLORS.text.primary,
        lineHeight: 1.3,
        wordBreak: 'break-word',
    },
});

interface InfoItemProps {
    label: React.ReactNode;
    value: React.ReactNode;
    className?: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value, className }) => {
    const classes = useStyles();

    return (
        <Box className={className}>
            <Typography component='span' className={classes.label}>
                {label}
            </Typography>

            <Typography component='div' className={classes.value}>
                {value}
            </Typography>
        </Box>
    );
};

export default InfoItem;
